import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['info', 'query', 'loader', 'results', 'selection', 'initial', 'modal', 'searchButton', 'loaderWait'];

  connect() {
    this.name = this.modalTarget.dataset.name;
    this.multiple = this.modalTarget.dataset.multiple != 'false';
    this.initialSelections = JSON.parse(this.initialTarget.dataset.selections);
    this.selections = this.initialSelections;
    this.loading = false;
    this.handleEnter = this.handleEnter.bind(this);
    this.lastFetch = null;
    this.render();
  }

  search() {
    if (this.loading || this.queryTarget.value.length < 3) {
      return;
    }
    this.loaderWaitTarget.classList.add('is-hidden');
    this.resultsTarget.classList.add('is-hidden');
    this.loaderTarget.classList.remove('is-hidden');
    this.loading = true;
    this.searchButtonTarget.disabled = true;

    this.resultsTarget.innerHTML = '';

    let currentFetch = fetch(`${this.data.get('url')}?layout=false&q=${this.queryTarget.value}`, { credentials: 'same-origin' });

    setTimeout(() => {
      if (this.loading) {
        this.loaderWaitTarget.classList.remove('is-hidden');
        this.searchButtonTarget.disabled = false;
        this.loading = false;
      }
    }, 3000);
    this.lastFetch = currentFetch;
    currentFetch
      .then((response) => response.text())
      .then((html) => {
        if (this.lastFetch != currentFetch) return;
        this.loaderWaitTarget.classList.add('is-hidden');
        this.loaderTarget.classList.add('is-hidden');
        this.resultsTarget.classList.remove('is-hidden');
        this.loading = false;
        this.resultsTarget.innerHTML = html;
        this.searchButtonTarget.disabled = false;
        this.render();
      })
      .catch((error) => {
        this.loaderWaitTarget.classList.add('is-hidden');
        this.loaderTarget.classList.add('is-hidden');
        this.resultsTarget.classList.remove('is-hidden');
        this.loading = false;
        this.resultsTarget.innerHTML = 'Произошла ошибка. Попробуйте повторить поиск.';
        this.searchButtonTarget.disabled = false;
      });
  }

  selectPart(event) {
    let part = { id: event.currentTarget.dataset.partId, info: event.currentTarget.dataset.partInfo };
    this.selections.push(part);
    this.render();
  }

  removePart(event) {
    this.selections = this.selections.filter((el) => el.id != event.target.dataset.partId);
    this.render();
  }

  submit() {
    this.initialSelections = this.selections;
    let ids = this.selections.map((element) => element.id);
    let infos = this.selections.map((element) => element.info);

    if (ids.length == 0) {
      var x = document.createElement('INPUT');
      x.setAttribute('type', 'hidden');
      x.setAttribute('name', this.name);
      x.setAttribute('value', '');
      this.infoTarget.parentNode.insertBefore(x, this.infoTarget);
    } else {
      ids.forEach((id) => {
        var x = document.createElement('INPUT');
        x.setAttribute('type', 'hidden');
        x.setAttribute('name', this.name);
        x.setAttribute('value', id);
        this.infoTarget.parentNode.insertBefore(x, this.infoTarget);
      });
    }

    this.infoTarget.value = infos.join(', ');

    this.closeModal();
  }

  openModal() {
    document.addEventListener('keypress', this.handleEnter);
  }

  closeModal() {
    this.selections = this.initialSelections;
    this.render();
    this.queryTarget.value = '';
    this.resultsTarget.innerHTML = '';
    document.removeEventListener('keypress', this.handleEnter);
  }

  handleEnter(event) {
    let key = event.which || event.keyCode;
    if (key === 13) {
      event.preventDefault();
      this.search();
    }
  }

  render() {
    if (!this.multiple) {
      this.selections = this.selections.slice(-1);
    }
    this.selectionTarget.innerHTML = '';
    let ids = new Set(this.selections.map((element) => element.id));
    let uniq_selections = [];
    ids.forEach((id) => {
      uniq_selections.push({ id: id, info: this.selections.find((x) => x.id === id).info });
      this.selectionTarget.insertAdjacentHTML(
        'beforeend',
        `<div class="control" data-part-id="${id}"
              data-part-info="${this.selections.find((x) => x.id === id).info}">
          <div class="tags has-addons">
            <span class="tag is-success">${this.selections.find((x) => x.id === id).info}</span>
            <div class="tag is-delete is-light" data-part-id="${id}" data-action="click->form--parts-modal#removePart"></div>
          </div>
        </div>`
      );
    });
    document.querySelectorAll('div[data-part-id]').forEach((el) => el.classList.remove('is-info'));

    ids.forEach((id) => {
      let btn = document.querySelector(`div[data-part-id="${id}"]`);
      if (btn) {
        btn.classList.add('is-info');
      }
    });
    this.selections = uniq_selections;
  }
}
